import { rem } from '@/styles/global';
import styled from 'styled-components';

export const Container = styled.div`
  width: ${rem(600)};
  height: 90vh;
`;
